import sub1_monitor1 from './sub1_monitor1.png'
import sub1_monitor2 from './sub1_monitor2.png'
import sub1_monitor3 from './sub1_monitor3.jpg'
import sub1_monitor4 from './sub1_monitor4.png'
import sub1_monitor5 from './sub1_monitor5.png'
import sub1_monitor6 from './sub1_monitor6.png'
import sub1_monitor7 from './sub1_monitor7.png'
import sub1_monitor8 from './sub1_monitor8.png'
import sub1_monitor9 from './sub1_monitor9.png'
import sub1_monitor10 from './sub1_monitor10.png'
import question1 from './question1.png'
import question2 from './question2.png'
import question3 from './question3.png'
import question4 from './question4.png'
import sub2_monitor1 from './sub2_monitor1.png'
import sub2_monitor2 from './sub2_monitor2.png'
import sub2_monitor3 from './sub2_monitor3.png'
import sub2_monitor4 from './sub2_monitor4.png'
import sub3_monitor1 from './sub3_monitor1.png'
import sub3_monitor2 from './sub3_monitor2.png'
import sub3_monitor3 from './sub3_monitor3.png'
import sub3_monitor4 from './sub3_monitor4.png'
import sub3_monitor5 from './sub3_monitor5.png'
import sub3_monitor6 from './sub3_monitor6.png'
import sub3_monitor7 from './sub3_monitor7.png'
import sub3_monitor8 from './sub3_monitor8.png'
import sub3_monitor9 from './sub3_monitor9.png'
import sub3_monitor10 from './sub3_monitor10.png'
import sub4_monitor1 from './sub4_monitor1.png'
import sub4_monitor2 from './sub4_monitor2.png'
import sub4_monitor3 from './sub4_monitor3.png'
import sub4_monitor4 from './sub4_monitor4.png'
import sub4_monitor5 from './sub4_monitor5.png'
import sub4_monitor6 from './sub4_monitor6.png'
import sub4_monitor7 from './sub4_monitor7.png'
import sub4_monitor8 from './sub4_monitor8.png'
import sub4_monitor9 from './sub4_monitor9.png'
import sub4_monitor10 from './sub4_monitor10.png'
import sub4_monitor11 from './sub4_monitor11.png'
import sub4_monitor12 from './sub4_monitor12.png'
import sub4_monitor13 from './sub4_monitor13.png'
import sub4_monitor14 from './sub4_monitor14.png'
import sub4_monitor15 from './sub4_monitor15.png'
import sub4_monitor16 from './sub4_monitor16.png'


export const imgsT5 = {
	sub1_monitor1,
	sub1_monitor2,
	sub1_monitor3,
	sub1_monitor4,
	sub1_monitor5,
	sub1_monitor6,
	sub1_monitor7,
	sub1_monitor8,
	sub1_monitor9,
	sub1_monitor10,
	question1,
	question2,
	question3,
	question4,
	sub2_monitor1,
	sub2_monitor2,
	sub2_monitor3,
	sub2_monitor4,
	sub3_monitor1,
	sub3_monitor2,
	sub3_monitor3,
	sub3_monitor4,
	sub3_monitor5,
	sub3_monitor6,
	sub3_monitor7,
	sub3_monitor8,
	sub3_monitor9,
	sub3_monitor10,
	sub4_monitor1,
	sub4_monitor2,
	sub4_monitor3,
	sub4_monitor4,
	sub4_monitor5,
	sub4_monitor6,
	sub4_monitor7,
	sub4_monitor8,
	sub4_monitor9,
	sub4_monitor10,
	sub4_monitor11,
	sub4_monitor12,
	sub4_monitor13,
	sub4_monitor14,
	sub4_monitor15,
	sub4_monitor16,
}